var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./document.constants";
export var getDetail = (_a = generatePromises(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, getInfiniteLoad = _a.getInfiniteLoad, create = _a.create, update = _a.update, updateMembers = _a.updateMembers, remove = _a.remove, getAllWhere = _a.getAllWhere, archive = _a.archive, unarchive = _a.unarchive;
